import React from 'react';
import type { CSSProperties } from 'react';
import styled from 'styled-components';

type StyleProps = {
  [K in keyof CSSProperties]?: CSSProperties[K];
};

type ContainerProps = React.PropsWithChildren<
  StyleProps & {
    onClick?: () => void;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
    className?: string;
    id?: string;
  }
>;

const camelToKebab = (str: string) => str.replace(/[A-Z]/g, (match) => `-${match.toLowerCase()}`);

const StyledContainer = styled.div<{ $styles: CSSProperties }>`
  ${({ $styles }) =>
    Object.entries($styles)
      .map(([key, value]) => {
        const kebabKey = camelToKebab(key);
        return `${kebabKey}: ${value};`;
      })
      .join('\n')}
`;

export const Container: React.FC<ContainerProps> = ({
  children,
  onClick,
  onMouseEnter,
  onMouseLeave,
  className,
  id,
  ...rest
}) => {
  return (
    <StyledContainer
      $styles={rest}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={className}
      id={id}
    >
      {children}
    </StyledContainer>
  );
};
